
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.995 5.997a5.997 5.997 0 11-11.994 0 5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M10.808 2.142h-4.35a.545.545 0 01-.386-.16L4.942.852a.547.547 0 00-.387-.16H1.53a.546.546 0 00-.547.546v7.278c0 .301.245.546.547.546h9.278a.546.546 0 00.546-.546V2.688a.546.546 0 00-.546-.546zM6.066 9.159v.69","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.875 10.659h2.504M2.74 10.659h2.504"}}),_c('g',{attrs:{"stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.875 10.659a.809.809 0 10-1.618 0 .809.809 0 001.618 0zM8.056 7.939H4.021a1.027 1.027 0 01-.086-2.05v-.008a1.2 1.2 0 011.672-1.102 1.429 1.429 0 012.37 1.378.893.893 0 11.08 1.782zm2.816-4.622H1.465a.481.481 0 00-.482.481v4.717c0 .302.245.547.547.547h9.278a.546.546 0 00.546-.547V3.798a.482.482 0 00-.482-.481z"}}),_c('path',{attrs:{"d":"M8.056 6.153a.996.996 0 00-.08.004 1.429 1.429 0 00-2.37-1.378A1.201 1.201 0 003.935 5.88l.001.009a1.026 1.026 0 00.086 2.049h4.035a.893.893 0 000-1.786zM10.457 7.271h.897M9.772 8.012h1.482"}})])])])
          )
        }
      }
    